import { createReducer, on } from "@ngrx/store";
import { AddressActions } from "../actions";
import { AddressState, initialAddressState } from "../address.state";

export const reducer = createReducer(
    initialAddressState,
    on(AddressActions.clear, (): AddressState => initialAddressState),
    on(
        AddressActions.getSuccess,
        AddressActions.createSuccess,
        AddressActions.updateSuccess,
        (state, { address }): AddressState => ({
            ...state,
            addresses: {
                ...state.addresses,
                [address.id]: address,
            },
        })
    )
);
